import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "../auth/services/auth.service";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const userDetails = this.auth.getUserInfo();
    if (userDetails && userDetails.AccessToken) {
      const newRequest = request.clone({
        headers: request.headers.set(
          "authorization",
          `Bearer ${userDetails.AccessToken}`
        ).set("WebToken", `${environment.webToken}`),
      });
      return next.handle(newRequest);
    } else {
      return next.handle(request);
    }
  }
}
